import { Grid, Page, Section } from 'ui';

import { PopularLinks } from '../components/PopularLinks/PopularLinks';
import { TabNavigation } from '../components/TabNavigation/TabNavigation';

export const GroundControl = () => {
  return (
    <Page>
      <Page.Title title="Ground Control 🚀" />
      <Page.Divider />
      <Grid container>
        <Grid item xs={12}>
          <Section>
            <TabNavigation />
          </Section>
        </Grid>
        <Grid item xs={12}>
          <Section title="Popular Links">
            <PopularLinks />
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
